import React from "react";
import "./style.css";

function Jumbotron() {
  return (
    <div className="jumbotron text-center">
      <img src="./imgs/banner.png" className="img-fluid" alt="Responsive image"/>
    </div>
  );
}

export default Jumbotron;
